/* eslint-disable no-throw-literal */
import "../App.scss";
import "../styles/fitSelector.scss";

import React, { useState, useEffect } from "react";
import navIcon from "../img/svg/navigation_icon.svg";
import dropdownIcon from "../img/svg/dropdown_icon.svg";
import LeumitHeroImg from "../img/backgroundroomchoice.png";
import Dropdown from "../shared/Dropdown";
import PhoneDialog from "../shared/PhoneDialog";
import LocationPopup from "../shared/locationPopup";
import swalDialog from "../helpers/swalErrorPopup";
import NotificationPopup from "../shared/notificationPopup";
import { useDispatch, useSelector } from "react-redux";
import { updateAllAppParams, updateAllClubParams } from "../store/appParamSlice";
import { isLoadChanger } from "../store/mainSlice";
import { useNavigate, useLocation } from "react-router-dom";
import { PoweredBy } from "../shared/PoweredBy";
import { useTranslation } from "react-i18next";
import clubAPI from "../api/clubAPI";
import moment from "moment";
import { chooseTextForBtn } from "../utils/helper";
import { isPartnerClalit, isPartnerLeumit, isPartnerMaoflaamit } from "../store/partnerStore";

export default function FitSelector() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isClalit = useSelector(isPartnerClalit);
  const isLeumit = useSelector(isPartnerLeumit);
  const isMaoflaamit = useSelector(isPartnerMaoflaamit);
  const userParams = useSelector((state) => state.userSlice.userData);
  const mainUserParams = useSelector((state) => state.userSlice.mainUserData);
  const cityAndClubs = useSelector((state) => state.appParamSlice.allAppParams);
  const clubCategories = useSelector((state) => state.appParamSlice.clubCategories);
  const isHaveCreditCard = useSelector((state) => state.userSlice.isHaveCreditCard);

  const [open, setOpen] = useState(false);
  const [openLocation, setOpenLocation] = useState(false);
  const [btnText, setBtnText] = useState(t("ENTER"));
  const [allClubs, setAllClubs] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedClub, setSelectedClub] = useState("");
  const [orderTimeRange, setOrderTimeRange] = useState([]);
  const [selectedClubCategory, setSelectedClubCategory] = useState("");
  const [selectedClubPhone, setSelectedClubPhone] = useState();
  const navigate = useNavigate();
  const location = useLocation();

  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [resetSub, setResetSub] = useState(false);

  const [selectedCategoryParam, setSelectedCategoryParam] = useState("");
  const [selectedSubCatParam, setSelectedSubCatParam] = useState("");

  const [openNotificationPopup, setOpenNotificationPopup] = useState(false);
  const [notificationText, setNotificationText] = useState("");

  const [clubIds, setClubIds] = useState([]);

  useEffect(() => {
    setDropdownOptions(
      clubCategories.map((category) => ({
        value: category.ID,
        label: category.Name,
      }))
    );
  }, [clubCategories, selectedSubCategory]);

  useEffect(() => {
    handleSelectSubCategory("");
    handleSelectClubCategory("");
    setDropdownOptions(
      clubCategories.map((category) => ({
        value: category.ID,
        label: category.Name,
      }))
    );
  }, [resetSub]);

  useEffect(() => {
    if (location?.state?.clubId && cityAndClubs?.ClubList) {
      const clubElem = cityAndClubs?.ClubList.find((el) => el.RecordID === location?.state?.clubId);
      setSelectedClub(clubElem);
    }
  }, [cityAndClubs]);

  useEffect(() => {
    if (Object.keys(cityAndClubs).length > 0) {
      setAllClubs(cityAndClubs.ClubList);
      setAllCities(cityAndClubs.CityList);
    }
  }, [cityAndClubs]);

  useEffect(() => {
    const fetch = async () => {
      let clubs = cityAndClubs?.ClubList;
      if (selectedCity) {
        clubs = clubs.filter((el) => el.AreaName.includes(selectedCity));
      }
      if (selectedClubCategory) {
        try {
          dispatch(isLoadChanger(true));
          let clubsInCategory = await clubAPI.getClubsByCategory({
            binID: userParams.BinID,
            mainCatID: selectedClubCategory.value,
            token: mainUserParams.Token,
            id: mainUserParams.ID,
            phone: mainUserParams.Phone,
          });
          const allowedClubs = JSON.parse(clubsInCategory.data.Data).ClubsList;

          clubs = clubs.filter((el) => allowedClubs.includes(el.RecordID));
          dispatch(isLoadChanger(false));
        } catch (err) {
          dispatch(isLoadChanger(false));
          swalDialog(err);
        }
      }
      if (selectedSubCategory) {
        clubs = clubs.filter((club) => clubIds.includes(club.RecordID));
      }

      setAllClubs(clubs);
    };
    fetch();
  }, [selectedCity, selectedClubCategory, selectedSubCategory, clubIds]);

  useEffect(() => {
    setBtnText(chooseTextForBtn(selectedClub, t));
    if (selectedClub) {
      getOrderTimeRange();
    }
  }, [selectedClub]);

  useEffect(() => {
    if (!!selectedCategoryParam && !!selectedSubCatParam) {
      const fetch = async () => {
        try {
          dispatch(isLoadChanger(true));

          const clubParamIds = await clubAPI.getClubsByCategory({
            binID: userParams.BinID,
            mainCatID: String(selectedCategoryParam.value),
            subCatID: String(selectedSubCatParam.value),
            token: mainUserParams.Token,
            id: mainUserParams.ID,
            phone: mainUserParams.Phone,
          });

          if (clubParamIds.data.Error !== 0) {
            dispatch(isLoadChanger(false));
            throw {
              code: clubParamIds.data.Error,
              mess: clubParamIds.data.Message,
            };
          }

          const parsedData = JSON.parse(clubParamIds.data.Data);

          setClubIds(parsedData.ClubsList);

          dispatch(isLoadChanger(false));
        } catch (err) {
          dispatch(isLoadChanger(false));
          swalDialog(err);
        }
      };
      if (userParams && Object.keys(userParams).length > 0) {
        fetch();
      }
    }
  }, [selectedCategoryParam, selectedSubCatParam, userParams]);

  useEffect(() => {
    const fetch = async () => {
      try {
        dispatch(isLoadChanger(true));
        const param = await clubAPI.getWebFullData({
          binID: userParams.BinID,
          token: mainUserParams.Token,
          id: mainUserParams.ID,
          phone: mainUserParams.Phone,
        });
        if (param.data.Error !== 0) {
          throw {
            code: param.data.Error,
            mess: param.data.Message,
          };
        }
        dispatch(updateAllAppParams(JSON.parse(param.data.Data)));
        const clubParam = await clubAPI.getClubCategoryList({
          binID: userParams.BinID,
          token: mainUserParams.Token,
          id: mainUserParams.ID,
          phone: mainUserParams.Phone,
        });

        if (clubParam.data.Error !== 0) {
          dispatch(isLoadChanger(false));
          throw {
            code: clubParam.data.Error,
            mess: clubParam.data.Message,
          };
        }

        dispatch(updateAllClubParams(JSON.parse(clubParam.data.Data)));
        dispatch(isLoadChanger(false));
      } catch (err) {
        dispatch(isLoadChanger(false));
        swalDialog(err);
      }
    };
    if (
      userParams &&
      Object.keys(userParams).length > 0 &&
      (clubCategories.length === 0 || Object.keys(cityAndClubs).length === 0)
    ) {
      fetch();
    }
  }, [userParams]);

  const handleSelectClubCategory = (selectedOption) => {
    setSelectedClubCategory(selectedOption);
    setSelectedCategoryParam(selectedOption);
    setSelectedSubCatParam("");
  };

  const handleSelectSubCategory = (selectedOption) => {
    setSelectedClubCategory("");
    setSelectedSubCategory(selectedOption);
    setSelectedSubCatParam(selectedOption);

    setIsDropdownOpen(false);
    setIsOpen(false);
  };

  const getOrderTimeRange = async () => {
    const orderTimeRange = await clubAPI.getOrderTimeRange({
      clubID: selectedClub.RecordID,
      token: mainUserParams.Token,
      id: mainUserParams.ID,
      phone: mainUserParams.Phone,
    });
    if (orderTimeRange.data?.Data) {
      const dates = JSON.parse(orderTimeRange.data?.Data);
      const clearDates = dates.map((date) => moment.unix(date).format("DD/MM/YYYY"));
      setOrderTimeRange(clearDates);
    }
  };

  const handleSelectCity = (selectedOption) => {
    setSelectedCity(selectedOption?.label ?? "");
  };

  const handleSelectClub = (selectedOption) => {
    const clubElem = cityAndClubs?.ClubList?.find((el) => el.RecordID === selectedOption?.value);
    setSelectedClub(clubElem ?? "");
  };

  const navigateToVenue = () => {
    navigate(`/venue/${selectedClub.RecordID}`, {
      state: {
        price: selectedClub.Price,
        clubId: selectedClub.RecordID,
        clubName: selectedClub.Name,
      },
    });
  };

  return (
    <div className="main-page-container">
      {isLeumit || isMaoflaamit ? (
        <div className="leumit-fit-selector">
          <img src={LeumitHeroImg} className="leumit-fit-selector-hero" alt="" />
          <div className="leumit-fit-selector-form">
            <Dropdown
              options={
                allCities && Array.isArray(allCities) && allCities.length > 0
                  ? allCities.map((el) => ({ value: el.RecordID, label: el.Name }))
                  : []
              }
              onSelect={handleSelectCity}
              imgUrl={navIcon}
              placeholder={t("SELECT_CITY")}
            />
            <Dropdown
              options={
                allClubs && Array.isArray(allClubs) && allClubs.length > 0
                  ? allClubs.map((el) => ({ value: el.RecordID, label: el.Name }))
                  : []
              }
              initValue={location?.state?.clubId}
              onSelect={handleSelectClub}
              imgUrl={dropdownIcon}
              isShouldRotate={true}
              isCitySelected={selectedCity}
              placeholder={t("SELECT_CLUB")}
            />
            <Dropdown
              options={
                clubCategories && Array.isArray(clubCategories) && clubCategories.length > 0
                  ? clubCategories.map((el) => ({ value: el.ID, label: el.Name }))
                  : []
              }
              onSelect={handleSelectClubCategory}
              imgUrl={dropdownIcon}
              isShouldRotate={true}
              placeholder={t("SEARCH_BY_CATEGORY")}
            />
            <button
              className="leumit-fit-selector-btn"
              onClick={navigateToVenue}
              disabled={!selectedClub}
            >
              {t("BOOK")}
            </button>
          </div>
        </div>
      ) : (
        <div className={isClalit ? "fit-selector-with-background" : "fit-selector-with-background-wow"}>
          <div className="main-page-btn-container">
            <Dropdown
              options={
                allCities && Array.isArray(allCities) && allCities.length > 0
                  ? allCities.map((el) => ({ value: el.RecordID, label: el.Name }))
                  : []
              }
              onSelect={handleSelectCity}
              imgUrl={navIcon}
              placeholder={t("SELECT_CITY")}
            />
            <Dropdown
              options={
                allClubs && Array.isArray(allClubs) && allClubs.length > 0
                  ? allClubs.map((el) => ({ value: el.RecordID, label: el.Name }))
                  : []
              }
              initValue={location?.state?.clubId}
              onSelect={handleSelectClub}
              imgUrl={dropdownIcon}
              isShouldRotate={true}
              isCitySelected={selectedCity}
              placeholder={t("SELECT_CLUB")}
            />
            <Dropdown
              options={
                clubCategories && Array.isArray(clubCategories) && clubCategories.length > 0
                  ? clubCategories.map((el) => ({ value: el.ID, label: el.Name }))
                  : []
              }
              onSelect={handleSelectClubCategory}
              imgUrl={dropdownIcon}
              isShouldRotate={true}
              placeholder={t("SEARCH_BY_CATEGORY")}
            />
            <button
              className="main-page-btn big-button very-big-button border-radius6px"
              onClick={navigateToVenue}
              disabled={!selectedClub}
            >
              {isClalit ? t("SELECT_CLUB") : t("SEARCH")}
            </button>
          </div>
        </div>
      )}
      {isClalit && (
        <div>
          <PoweredBy full={true} />
        </div>
      )}
      <PhoneDialog
        isOpen={open}
        phone={selectedClubPhone}
        setIsOpen={setOpen}
        redirectToAnotherPage={() =>
          navigate("/selectDateTime", {
            state: {
              clubId: selectedClub.RecordID,
              clubName: selectedClub.Name,
              orderTimeRange: orderTimeRange,
            },
          })
        }
      />
      <LocationPopup
        isOpen={openLocation}
        setIsOpen={setOpenLocation}
        headerTextTop={t("CLUB_ENTRY_NOT_POSSIBLE")}
        headerTextBottom={t("CLUB_ENTRY_NOT_POSSIBLE_END")}
        bodyText={t("CLUB_ENTRY_NEARBY_ONLY")}
      />

      <NotificationPopup
        isOpen={openNotificationPopup}
        setIsOpen={setOpenNotificationPopup}
        bodyText={notificationText}
        btnText={t("CLOSE")}
      />
    </div>
  );
}
